import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import chatService from '../services'

export function useMutationConnectLine(roomId: string) {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: () => chatService.connectLine(roomId),
		onSuccess: () => {
			// Invalidate room query to refresh player.lineId
			queryClient.invalidateQueries({ queryKey: ['chat', 'room', roomId] })
			toast.success('เชื่อมต่อ LINE สำเร็จ')
		},
		onError: (error: Error) => {
			const message =
				(error as unknown as { response?: { data?: { message?: string } } })
					?.response?.data?.message ||
				'เชื่อมต่อ LINE ล้มเหลว กรุณาลองใหม่อีกครั้ง'
			toast.error(message)
		},
	})
}
